import Input from 'components/common/Input';
import SearchIcon from 'components/icons/SearchIcon';
import Button from 'components/common/Button';
import Colors from 'assets/Colors';
import SelectRole from 'components/common/SelectRole';
import List from 'components/icons/List';
import Thumbnails from 'components/icons/Thumbnails';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import s from '../../../styles/TopMenu.styles';

const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  width: 97%;
  margin: auto auto;
  margin-top: 10px;
  box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.06);
  padding: 19px 18px 19px 19px;
  border-radius: 5px;
  margin-bottom: 30px;
  @media (max-width: 1226px) {
    grid-template-columns: 1fr;
  }
`;

function TopMenu({
  changeSearchValue,
  addWorker,
  viewType,
  setviewType,
  setrolViewList,
  loading,
}) {
  const { t } = useTranslation();
  return (
    <Container>
      <s.LeftContainer style={{ marginRight: '14px' }}>
        <Row>
          <Col
            style={{ marginRight: '14px' }}
            xs={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 11 }}
          >
            <s.Title>
              {t('components.EmployeesList.TopMenu.searchItems')}
            </s.Title>
            <Input
              disabled={loading}
              placeholder={t('components.EmployeesList.TopMenu.search')}
              style={{
                marginBottom: '14px',
                // maxWidth: "340px",
                minWidth: '200px',
                width: '100%',
              }}
              prefix={<SearchIcon />}
              onChange={(e) => changeSearchValue(e.target.value)}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
            <s.LeftContainer>
              <s.Title>
                {t('components.EmployeesList.TopMenu.selectRole')}
              </s.Title>
              <SelectRole setrolViewList={setrolViewList} disabled={loading} />
            </s.LeftContainer>
          </Col>
        </Row>
      </s.LeftContainer>

      <s.RightContainer>
        <Row>
          <Col
            style={{
              display: 'flex',
              marginRight: '30px',
              marginTop: '12px',
            }}
          >
            <Button
              disabled={loading}
              type="link"
              style={{
                marginLeft: '-10px',
                border: 'none',
              }}
              onClick={() => setviewType('list')}
            >
              <List color={viewType === 'list' ? Colors.primary : '#959FAF'} />
            </Button>

            <Button
              disabled={loading}
              type="link"
              style={{
                border: 'none',
              }}
              onClick={() => setviewType('thumbnails')}
            >
              <Thumbnails
                color={viewType === 'thumbnails' ? Colors.primary : '#959FAF'}
              />
            </Button>
          </Col>
          <Col style={{ marginTop: '12px' }}>
            <Button
              disabled={loading}
              type="primary"
              style={{
                background: Colors.primary,
                color: Colors.text_on_secondary,
                width: 'none',
                fontWeight: '500',
                border: 'none',
                height: '40px',
              }}
              onClick={addWorker}
            >
              {t('components.EmployeesList.TopMenu.addArticle')}
            </Button>
          </Col>
        </Row>
      </s.RightContainer>
    </Container>
  );
}

export default TopMenu;
